import React from "react"
import { PlayCircleFilled } from "@ant-design/icons"
import { isAuthenticated, redirectToOmnicuris, secondsToTime } from "../../utilities"
import { INITIATE_AUTH_DRAWER } from "../../actions/types"
import { useDispatch } from "react-redux"

function SectionCard({ cardItems }) {
  const dispatch = useDispatch()

  const navigate = (ev) => {
    ev.stopPropagation()
    if (!isAuthenticated() && window.self === window.top) {
      dispatch({
        type: INITIATE_AUTH_DRAWER,
      })
    } else {
      // redirectToOmnicuris(`/${cardItems.productType === 'EXPERT_TALK' ? 'oc-originals' : 'academics'}/${cardItems.slug ? cardItems.slug : cardItems.id}`, window.self != window.top);
    }
  }

  return (
    <div className="sectionCardContainer" onClick={navigate}>
      <div className="sectionCard">
        <div className="sectionCardMedia">
          <img src={cardItems.portraitThumbnail ? cardItems.portraitThumbnail : cardItems.landscapeThumbnail ? cardItems.landscapeThumbnail : cardItems.media} alt={cardItems.title} />
        </div>
      </div>
      <div className="sectionCardHover">
        <div className="sectionCardMedia">
          <img src={cardItems.portraitThumbnail ? cardItems.portraitThumbnail : cardItems.landscapeThumbnail ? cardItems.landscapeThumbnail : cardItems.media} alt={cardItems.title} />
        </div>
        <div className="sectionCardContent">
          <button className="sectionCardWatchNow">
            <PlayCircleFilled />
            WATCH NOW
          </button>
          <h3>{cardItems.title}</h3>
          <p>{secondsToTime(cardItems.duration)}</p>
        </div>
      </div>
    </div>
  )
}

export default SectionCard
